import { createFileRoute } from "@tanstack/react-router";
import { SellOrderRequests } from "@/components/SellOrderRequests";

function RouteComponent() {
  return <SellOrderRequests />;
}

export const Route = createFileRoute("/_authenticated/sell-order-requests/")({
  component: RouteComponent,
  staticData: { page: "deals" },
});
